export default __webpack_public_path__ + "static/media/Anwesh-Gangula.a3359457.avif";